<template>
	<div>
		<!-- 搜索栏目 -->
		<div style="width: 100%">
			<div class="el-search" style="border-radius: 0">
				<div class="el-left">
					<el-button
						type="primary"
						size="small"
						icon="el-icon-plus"
						@click="$emit('add-edit-theme', 0)">
						{{ $t("common.add") }}
					</el-button>
					<el-button
						type="primary"
						size="small"
						icon="el-icon-edit"
						@click="$emit('add-edit-theme', 'admin')"
						v-hasPerm="['myapps:theme:admindefault']">
						{{ $t("theme.setDefaultTheme") }}
					</el-button>
				</div>
				<div class="el-right">
					<el-form
						:model="themeSearch"
						:inline="true"
						size="small"
						class="demo-form-inline">
						<el-form-item prop="no" style="margin-bottom: 10px; margin-right: 0">
							<el-input
								v-model="themeSearch.userName"
								:placeholder="$t('ecigarette.userName')"></el-input>
						</el-form-item>
						<el-form-item prop="no" style="margin-bottom: 10px; margin-right: 0">
							<el-input
								v-model="themeSearch.equipmentNo"
								:placeholder="$t('icardwater.equipmentNo')"></el-input>
						</el-form-item>
						<el-form-item prop="name" style="margin-bottom: 10px; margin-right: 0">
							<el-input
								v-model="themeSearch.name"
								:placeholder="$t('themelist.names')"></el-input>
						</el-form-item>
						<el-form-item style="margin-bottom: 10px; margin-right: 0">
							<el-button type="primary" icon="el-icon-search" @click="$emit('search-theme')">
								{{ $t("common.search") }}
							</el-button>
							<el-button icon="el-icon-refresh" @click="$emit('reset-theme')">
								{{ $t("common.reset") }}
							</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>

		<!-- 主题列表 -->
		<el-table v-loading="loadingTheme" :data="themeTableData" border style="width: 100%">
			<el-table-column
				prop="userName"
				:label="$t('ecigarette.userName')"
				width="200"
				:align="'center'"></el-table-column>
			<el-table-column
				prop="name"
				:label="$t('themelist.name')"
				width="200"
				:align="'center'"></el-table-column>
			<el-table-column
				prop="mould"
				:label="$t('themelist.template')"
				:align="'center'"
				:formatter="formatterThemeTemplate"></el-table-column>
			<el-table-column
				prop="mainTone"
				:label="$t('themelist.color')"
				:align="'center'"
				width="130"
				filter-placement="bottom-end">
				<template #default="scope">
					<div
						:style="{
							'background-color': scope.row.mainTone,
							display: 'inline-block',
							height: '21px',
							width: '21px',
							'line-height': '21px',
							'border-radius': '4px',
							'box-sizing': 'border-box',
							'white-space': 'nowrap',
							border: '1px solid #dcdfe6',
							cursor: 'pointer',
						}"></div>
				</template>
			</el-table-column>
			<el-table-column
				prop="userEquipment"
				:label="$t('themelist.userEquipment')"
				:align="'center'"
				width="300">
				<template #default="scope">
					{{ handlerShowConfigMachine(scope.row.userEquipment) }}
				</template>
			</el-table-column>
			<el-table-column fixed="right" :label="$t('common.operate')" min-width="402" :align="'center'">
				<template slot-scope="scope">
					<el-button
						type="warning"
						icon="el-icon-folder-add"
						size="mini"
						style="padding: 7px"
						@click="$emit('add-machine', 1, scope.row.id)">
						{{ $t("themelist.addMachine") }}
					</el-button>
					<el-button
						type="warning"
						icon="el-icon-folder-opened"
						size="mini"
						style="padding: 7px"
						@click="$emit('theme-machine', scope.row.id)">
						{{ $t("themelist.mngMachine") }}
					</el-button>
					<el-button
						icon="el-icon-edit-outline"
						size="mini"
						style="padding: 7px"
						@click="$emit('add-edit-theme', 1, scope.row)">
						{{ $t("common.edit") }}
					</el-button>
					<el-button
						type="danger"
						icon="el-icon-delete"
						size="mini"
						style="padding: 7px"
						@click="$emit('delete-theme', scope.row.id)">
						{{ $t("common.delete") }}
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<el-pagination
			v-if="themePage.totalSize > 0"
			background
			layout="total,sizes,prev, pager, next,jumper"
			:current-page="themePage.pageIndex"
			:total="themePage.totalSize"
			:page-size="themePage.pageSize"
			@size-change="$emit('size-change', $event)"
			@current-change="$emit('page-change', $event)"></el-pagination>
	</div>
</template>

<script>
export default {
	name: "ThemeListTop",
	props: {
		themeSearch: {
			type: Object,
			required: true,
		},
		loadingTheme: {
			type: Boolean,
			required: true,
		},
		themeTableData: {
			type: Array,
			required: true,
		},
		themePage: {
			type: Object,
			required: true,
		},
		formatterThemeTemplate: {
			type: Function,
			required: true,
		},
		handlerShowConfigMachine: {
			type: Function,
			required: true,
		},
	},
};
</script>
